import { FastFilters, TScheduledClick } from '../fast_filters';
import { appendPreloader } from '../preloader';

export function initSelect(fastFilters: FastFilters, dataMark: TScheduledClick) {
  const container = document.querySelector(`[data-mark="${dataMark}"]`);

  if (!container) {
    return () => [];
  }

  const span = container.querySelector('span');

  if (!span) {
    return () => [];
  }

  let removeLoader: (() => void) | undefined;

  const clickListener = (e: MouseEvent) => {
    fastFilters.scheduleClick(dataMark, () => {
      if (removeLoader) {
        removeLoader();
        removeLoader = undefined;
      }
    });
    removeLoader = appendPreloader(span, {
      size: 15,
      style: 'position:relative;top:2px;margin-left:8px;',
    });
  };

  span.addEventListener('click', clickListener);

  return () => {
    span.removeEventListener('click', clickListener);
  };
}

const normalizeNumber = (originalString: string) => {
  const normalizedString = originalString.replace(/[^0-9]/g, '');

  return normalizedString === '' ? undefined : Number(normalizedString);
};

export const initRange = (
  fastFilters: FastFilters,
  dataMark: string,
  setMinValue: (value: number | undefined) => void,
  setMaxValue: (value: number | undefined) => void,
) => {
  const container = document.querySelector(`[data-mark="${dataMark}"]`);

  if (!container) {
    return () => [];
  }

  const inputs = container.querySelectorAll('input');

  if (inputs.length !== 2) {
    return () => [];
  }

  const [minInput, maxInput] = Array.from(inputs);

  const minInputListener = (e: KeyboardEvent) => setMinValue(normalizeNumber(minInput.value));

  const maxInputListener = (e: KeyboardEvent) => setMaxValue(normalizeNumber(maxInput.value));

  minInput.addEventListener('input', minInputListener);
  maxInput.addEventListener('input', maxInputListener);

  return () => {
    minInput.removeEventListener('input', minInputListener);
    maxInput.removeEventListener('input', maxInputListener);
  };
};
